import Flickity from 'flickity-fade'
import 'flickity-as-nav-for/as-nav-for'
import "regenerator-runtime/runtime";
import inView from 'in-view'
import { gsap } from 'gsap';
import Choices from 'choices.js/src/scripts/choices';
import { Container } from 'choices.js/src/scripts/components';

require('fslightbox');

const HTML = document.querySelector('html');
const lw_logo = document.querySelector('._lw_logo');
const pointer_events = window.PointerEvent ? {
    end: 'pointerup',
    enter: 'pointerenter',
    leave: 'pointerleave'
} : {
    end: 'touchend',
    enter: 'mouseenter',
    leave: 'mouseleave'
};
var dropdown_timeout;
var news_timeout;

class App {
    constructor() {
        // In view
        inView('.js-reveal:not(.is-visible)').on('enter', (el) => {
            el.classList.add('is-visible');
            el.dispatchEvent(new Event('inviewport'));
        });

        // Largo Winch large horizontal logo in the background
        function lw_logo_offsetter() {
            let header = document.querySelector('header');
            let banner = document.querySelector('section.banner');
            let albump = document.querySelector('.catalog-album');
            let offset = 0;

            if (lw_logo) {
                if (header) { offset += header.offsetHeight; }
                if (banner) { offset += banner.offsetHeight; }
                if (albump) { offset += (albump.offsetHeight / 2); }

                lw_logo.style.setProperty('--lwLogoOffsetTop', offset+'px');
                if (!lw_logo.classList.contains('lwl-active')) { lw_logo.classList.add('lwl-active'); }
            } else {
                if (header) { offset += header.offsetHeight; }
                document.body.style.setProperty('--lwParallaxOffsetTop', Math.round(offset)+'px');
            }
        }

        function lw_logo_parallax() {
            let offsetY = window.scrollY / Math.PI;
            if (lw_logo) {
                lw_logo.style.setProperty('--lwLogoScrollOffsetTop', Math.round(offsetY)+'px');
            } else {
                document.body.style.setProperty('--lwParallaxScrollOffsetTop', Math.round(offsetY)+'px');
            }
        }
        
        
        window.onscroll = lw_logo_parallax;

        this.init();
        lw_logo_offsetter();

        // Burger menu
        let burger = document.querySelector('.menu-burger');
        let closeBurger = document.querySelector('.close-burger');
        if (burger) {
            burger.addEventListener('click', (e) => {
                e.preventDefault(), e.stopPropagation();
                HTML.classList.add('open-menu');
                HTML.classList.remove('hide-header');
            });

            closeBurger.addEventListener('click', (e) => {
                e.preventDefault(), e.stopPropagation();
                HTML.classList.remove('open-menu')
            })
        }

        return this;
    }

    /**
     * Init the page
     * @return {object} The current instance
     */
    init() {
        this.initSearch();
        this.initDropdownMenu();
        this.initCarouselHome();
        this.initCarouselMiniatures();
        this.initCarouselPersonnages();
        this.lazyLoading();
        this.initFreeScrollCarousel();
        this.initReader();
        this.initPlayer();
        this.initCart();
        this.initNewsActions();
        this.initListsActions();
        this.initInViewItems();
        this.initTabs();
        this.initReadMore();
        this.initAnchorBtns();
        this.initAlertsBtns();
        this.initUrlHash();
        this.initNewsletter();
        this.initNewsGallery();

        return this;
    }

    /**
     * Init Dropdown menu
     */
    initDropdownMenu() {
        let dropdown = document.querySelector('.root-dropdown');
        let dropdown_wrapper = document.querySelector('.root-dropdown__wrapper');

        // Dropdown menu generator
        let menu_items = document.querySelectorAll('.nav__main--el[data-dropdown]');
        if (menu_items) {
            menu_items.forEach((el) => {
                el.addEventListener(pointer_events.end, (e) => {
                    e.preventDefault(), e.stopPropagation(), this._toggle_dropdown(el, dropdown, dropdown_wrapper);
                }), el.addEventListener(pointer_events.enter, (e) => {
                    if (e.pointerType == 'touch') return;
                    this._td_stop_close_timeout(dropdown, dropdown_wrapper), this._open_dropdown(el, dropdown, dropdown_wrapper);
                }), el.addEventListener(pointer_events.leave, (e) => {
                    if (e.pointerType == 'touch') return;
                    this._td_start_close_timeout(dropdown, dropdown_wrapper);
                });
            });

            let dropdown_els = document.querySelectorAll('.root-dropdown__wrapper--el');
            if (dropdown_els) {
                dropdown_els.forEach((el) => {
                    el.addEventListener(pointer_events.end, (e) => {
                        e.stopPropagation();
                    }), el.addEventListener(pointer_events.enter, (e) => {
                        if (e.pointerType == 'touch') return;
                        this._td_stop_close_timeout(dropdown, dropdown_wrapper);
                    }), el.addEventListener(pointer_events.leave, (e) => {
                        if (e.pointerType == 'touch') return;
                        this._td_start_close_timeout(dropdown, dropdown_wrapper);
                    });
                });
            }
        }
    }

    /**
     * Init the homepage carousel
     */
    initCarouselHome() {
        let carousels = document.querySelectorAll('.carousel-main');

        if (carousels) {
            carousels.forEach((el) => {
                let cells_container = el.querySelector('.carousel-main__container');

                let flkty = new Flickity(cells_container, {
                    lazyLoad: 3,
                    wrapAround: true,
                    fade : true,
                    adaptiveHeight: true,
                    initialIndex: -1,
                    prevNextButtons: true,
                    autoPlay: false
                });
            });
        }
    }

    /**
     * Carousel on the products miniatures
     */
    initCarouselMiniatures() {
        let miniatures_carousel = document.querySelector('._mCi');
        
        if (miniatures_carousel) {
            let flkty = new Flickity(miniatures_carousel, {
                contain: true,
                cellAlign: 'left',
                prevNextButtons: false,
                adaptiveHeight: false,
                watchCss: true,
                pageDots: false,
                on: {
                    dragStart : function() {
                        flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = 'none')
                    },
                    dragEnd : function() {
                        flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = 'all')
                    }
                }
            });

            let miniatures = document.querySelectorAll('._mIt');

            if (miniatures) {
                miniatures.forEach((el) => {
                    el.addEventListener('click', (e) => {
                        let main_img = document.querySelector('._mMi');
                        let old_focus = document.querySelector('._mIt.-focused');
    
                        if (main_img) {
                            if (el.classList.contains('-focused')) {
                                return;
                            } else {
                                el.classList.add('-focused');
                                old_focus.classList.remove('-focused');
                                gsap.to(main_img, {duration: 0.25, autoAlpha: 0});
                                setTimeout(() => {
                                    main_img.src = el.children[0].src;
                                    gsap.to(main_img, {duration: 0.25, autoAlpha: 1});
                                }, 251);
                            }
                        }
                    });
                });
            }
        }
    }

    /**
     * Init carousel on the persos
     */
    initCarouselPersonnages() {
        let persos_carousel = document.querySelector('._uCar:not([data-listener="true"])');

        if (persos_carousel) {
            if (persos_carousel.dataset.wraparound === 'false') {
                var wrapAroundValue = false;
            } else {
                var wrapAroundValue = true;
            }

            window.flkty_persos = new Flickity(persos_carousel, {
                lazyLoad: 5,
                contain: false,
                cellAlign: 'center',
                prevNextButtons: false,
                adaptiveHeight: false,
                watchCss: true,
                pageDots: true,
                wrapAround: wrapAroundValue,
                on: {
                    dragStart: () => {
                        window.flkty_persos.slider.childNodes.forEach(slide => slide.style.pointerEvents = 'none')
                    },
                    dragEnd: () => {
                        window.flkty_persos.slider.childNodes.forEach(slide => slide.style.pointerEvents = 'all')
                    },
                    change: () => {
                        let cell =  document.querySelector('._lMore_i.is-selected');

                        if (cell) {
                            if (cell.dataset.slug) {
                                var url = site_url+'load/perso/'+cell.dataset.slug;
                            } else {
                                let filter = document.querySelector('.list-filters li.active').dataset.filter;
                                var url = site_url+'load/auteur/'+cell.dataset.id+'/'+filter;
                            }
                            
                            let container = document.querySelector('._uDsc');

                            this._fetch_dispatcher(url, 'GET', container);
                        }
                    },
                    staticClick: (event, pointer, cellElement, cellIndex) => {
                        if (typeof cellIndex == 'number') {
                            window.flkty_persos.selectCell(cellIndex);
                        }
                    }
                }
            });
        }
    }

    /**
     * Lazyload images
     */
    lazyLoading() {
        let lazy_img = document.querySelectorAll('img.js-lazy:not(.lazy-loaded)');

        if (lazy_img) {
            let trigger = () => {
                lazy_img.forEach(async (el) => {
                    if (el.classList.contains('lazy-loaded')) {
                        return;
                    } else {
                        let bcr = el.getBoundingClientRect();
                        
                        if (bcr.top < (window.innerHeight + 500)) {
                            const imgLoadPromise = new Promise((resolve) => {
                                let img = new Image();
                                img.onload = () => {
                                    el.src = img.src;
                                    el.classList.add('lazy-loaded');
            
                                    if (el.closest('figure')) {
                                        el.closest('figure').classList.add('img-is-loaded');
                                    }
                                    
                                    delete el.dataset.src;

                                    if (el.parentElement.querySelector('.to_del_lazy')) {
                                        gsap.to(el.parentElement.querySelector('.to_del_lazy'), {duration: 0.25, autoAlpha: 0, display: 'none', ease: 'cubic.inOut'});
                                        setTimeout(() => {
                                            if (el.parentElement.querySelector('.to_del_lazy')) {
                                                el.parentElement.querySelector('.to_del_lazy').remove();
                                            } else {
                                                return;
                                            }
                                        }, 250);
                                    }
                                }

                                img.src = el.dataset.src;
                            });

                            await imgLoadPromise;
                        }
                    }
                });
            }
            
            trigger();

            window.addEventListener('scroll', trigger);
            window.addEventListener('resize', trigger);
        }
    }

    /**
     * Carousel free scroll init
     */
    initFreeScrollCarousel() {
        let carousel = document.querySelectorAll('.carousel:not([data-listener="true"])');

        if (carousel) {
            let index = 0;
            window.flkty_fs = new Array();
            carousel.forEach((el) => {
                el.dataset.listener = true;

                if (el.dataset.wraparound == 'true') {
                    var wrapAroundValue = true;
                } else {
                    var wrapAroundValue = false;
                }

                if (el.dataset.dots == 'true') {
                    var pageDotsValue = true;
                } else {
                    var pageDotsValue = false;
                }

                if (el.dataset.align) {
                    var cellAlignValue = el.dataset.align;
                } else {
                    var cellAlignValue = 'center';
                }
                
                window.flkty_fs[index] = new Flickity(el, {
                    freeScroll: true,
                    wrapAround: wrapAroundValue,
                    cellSelector: '.carousel__item, .carousel__product',
                    cellAlign: cellAlignValue,
                    groupCells: 1,
                    contain: true,
                    lazyLoad: 6,
                    prevNextButtons: false,
                    pageDots: pageDotsValue,
                    on : {
                        dragStart: function () {
                            this.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none");
                        },
                        dragEnd: function () {
                            this.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all");
                        }
                    }
                });

                index++;
            });
        }
    }

    /**
     * Init all bd readers and add a listener to the buttons added with the ajax called objects
     */
    initReader() {
        let reader_btns = document.querySelectorAll('._bdR');

        if (reader_btns) {
            reader_btns.forEach((el) => {
                if (el.dataset.listener === true) {
                    return;
                } else {
                    el.dataset.listener = true;
                    el.addEventListener('click', (e) => {
                        e.preventDefault();
    
                        this._bdreader_builder(el.dataset.token);
                    });
                }
            });
        }
    }

    /**
     * Init video players
     */
    initPlayer() {
        let player_btns = document.querySelectorAll('._vPlr');

        if (player_btns) {
            player_btns.forEach((el) => {
                if (el.dataset.listener === true) {
                    return;
                } else {
                    el.dataset.listener = true;
                    el.addEventListener('click', (e) => {
                        e.preventDefault();
    
                        this._vplayer_builder(el.dataset.token);
                    });
                }
            });
        }
    }

    /**
     * Init cart buttons and actions
     */
    initCart() {
        let cart_btns = document.querySelectorAll('._aTcrt:not([data-listener="true"])');

        if (cart_btns) {
            cart_btns.forEach((el) => {
                el.dataset.listener = true;
                
                el.addEventListener('click', (e) => {
                    e.preventDefault(), e.stopPropagation();

                    let ean = el.dataset.ean;
                    let url = site_url+'cart/add';

                    if (ean) {
                        let form_data = new FormData();
                        form_data.append('ean', ean);

                        // little onclick animation
                        let add_one = document.createElement('span');
                        add_one.classList.add('add-item');
                        add_one.textContent = '+1';

                        el.appendChild(add_one);

                        this._fetch_dispatcher(url, 'POST', el, form_data);

                        //setTimeout(() => { add_one.remove(); }, 1001);
                    }
                });
            });
        }

        // Here init the cart qty buttons
        let cart_items = document.querySelectorAll('._cItm:not([data-listener="true"])');

        if (cart_items) {
            cart_items.forEach((el) => {
                el.dataset.listener = true;
                this._cart_qty_btns(el, el.dataset.ean);
            });
        }

        // Here init the hover of the cart in the header
        let header_cart = document.querySelector('._bCrt:not([data-listener="true"])');
        if (header_cart) { var dropdown_cart = header_cart.parentElement.querySelector('.cart:not([data-listener="true"])'); }

        if (header_cart && dropdown_cart) {
            header_cart.dataset.listener = true;
            dropdown_cart.dataset.listener = true;
            let dropdown_cart_wrapper = dropdown_cart.querySelector('.cart__wrapper');

            header_cart.addEventListener(pointer_events.end, (e) => {
                e.stopPropagation();
            }), header_cart.addEventListener(pointer_events.enter, (e) => {
                if (e.pointerType == 'touch' && dropdown_cart.classList.contains('cart-visible')) {
                    open_cart_close_timeout(dropdown_cart, dropdown_cart_wrapper);
                } else {
                    clearTimeout(dropdown_timeout), open_cart_dropdown(dropdown_cart, dropdown_cart_wrapper);
                }
            }), header_cart.addEventListener(pointer_events.leave, (e) => {
                if (e.pointerType == 'touch') return;
                open_cart_close_timeout(dropdown_cart, dropdown_cart_wrapper);
            });

            dropdown_cart.addEventListener(pointer_events.end, (e) => {
                e.stopPropagation();
            }), dropdown_cart.addEventListener(pointer_events.enter, (e) => {
                open_cart_stop_timeout();
            }), dropdown_cart.addEventListener(pointer_events.leave, (e) => {
                if (e.pointerType == 'touch') return;
                open_cart_close_timeout(dropdown_cart, dropdown_cart_wrapper);
            });

            function open_cart_dropdown(dropdown, dropdown_wrapper) {
                dropdown.classList.add('cart-visible');
                dropdown.style.setProperty('--cartRotateX', '0deg');
            }

            function open_cart_close_timeout(dropdown, dropdown_wrapper) {
                dropdown_timeout = setTimeout(() => {
                    dropdown.classList.remove('cart-visible');
                    dropdown.style.removeProperty('--cartRotateX');
                }, 150);
            }

            function open_cart_stop_timeout() {
                clearTimeout(dropdown_timeout);
            }
        }
    }

    /**
     * Init news actions
     */
    initNewsActions() {
        let news = document.querySelectorAll('._nws:not([data-listener="true"])');

        if (news) {
            news.forEach((el) => {
                el.dataset.listener = true;

                let childrens = Array(
                    el.querySelector('.type'),
                    el.querySelector('.title'),
                    el.querySelector('.link')
                );

                el.addEventListener(pointer_events.end, (e) => {
                    e.preventDefault(), e.stopPropagation();
                }), el.addEventListener(pointer_events.enter, (e) => {
                    if (e.pointerType == 'touch') return;
                    _new_open_infos(childrens);
                }), el.addEventListener(pointer_events.leave, (e) => {
                    if (e.pointerType == 'touch') return;
                    _new_close_infos(childrens);
                });
            });

            function _new_open_infos(childrens) {
                gsap.to(childrens[1], {duration: 0.25, display: 'none', autoAlpha: 0, ease: 'power4.inOut'});
                news_timeout = setTimeout(() => {
                    childrens[1].classList.remove('smaller');
                    childrens.forEach((el, index) => {
                        setTimeout(() => {
                            gsap.to(el, {duration: 0.25, display: 'block', autoAlpha: 1, ease: 'power4.inOut'});
                        }, 100 * index + 1);
                    });
                }, 251);
            }

            function _new_close_infos(childrens) {
                clearTimeout(news_timeout);
                childrens.forEach((el, index) => {
                    setTimeout(() => {
                        gsap.to(el, {duration: 0.25, autoAlpha: 0, ease: 'power4.inOut'});
                    }, 100 * index + 1);
                });

                setTimeout(() => { childrens[1].classList.add('smaller'); }, 353);
                setTimeout(() => {
                    childrens.forEach((el) => { el.style.display = 'none'; });
                    gsap.to(childrens[1], {duration: 0.25, display: 'block', autoAlpha: 1, ease: 'power4.inOut'});
                }, 354);
            }
        }
    }

    /**
     * Init lists action buttons (ajax increment list at bottom or filter items)
     * 
     * Setup: add a data-type to the button to pass the type of list you're about to load
     *          add the data-type to each items too and the class "_lMore_i" to count the offset
     */
    initListsActions() {
        let btns = document.querySelectorAll('._lMore:not([data-listener="true"]), .list-filters li[data-filter]:not([data-listener="true"])');
        
        if (btns) {
            btns.forEach((el) => {
                el.dataset.listener = true;
                el.addEventListener('click', (e) => {
                    e.preventDefault(), e.stopPropagation();
                    if (el.classList.contains('active')) { return; }
                    if (!el.dataset.type) { throw new Error('Please specify a data-type on the HTMLElement'); }
                    if (el.nodeName === 'LI') { // Add the filter type to the load more button if it exists
                        btns.forEach((el) => { if (el.classList.contains('active')) { el.classList.remove('active'); } });
                        el.classList.add('active');
                        if (document.querySelector('._lMore[data-listener="true"][data-type="'+el.dataset.type+'"]')) {
                            let lmore_btn = document.querySelector('._lMore[data-listener="true"][data-type="'+el.dataset.type+'"]');
                            lmore_btn.dataset.lmfilter = el.dataset.filter; // lmfilter for load_more filter
                        }
                    }

                    // Get the offset
                    let offset = document.querySelectorAll('._lMore_i[data-type="'+el.dataset.type+'"]').length;
                    if (el.dataset.filter) {
                        var url = base_url+'dispatcher/filter/'+el.dataset.type+'/'+el.dataset.filter;
                    } else {
                        if (el.dataset.lmfilter) {
                            var url = base_url+'dispatcher/load_more/'+el.dataset.type+'/'+offset+'/'+el.dataset.lmfilter;
                        } else {
                            var url = base_url+'dispatcher/load_more/'+el.dataset.type+'/'+offset;
                        }
                    }
                    
                    let container = document.querySelector('._lMore_i[data-type="'+el.dataset.type+'"]').parentElement;
                    this._fetch_dispatcher(url, 'GET', container);
                });
            });
        }
    }

    /**
     * Animate items when arriving in viewport
     */
    initInViewItems() {
        inView('.js-load:not(.js-show)').on('enter', (el) => {
            el.classList.add('js-show');
            el.dispatchEvent(new Event('inviewport'));
        });
    }

    /**
     * Create tabs
     */
    initTabs() {
        let tabs = document.querySelectorAll('.tabs');

        if( tabs ) {
            let initialClick = 0;

            tabs.forEach((el) => {
                let current = -1;
                let container = el.querySelector('.tabs__container')
                let list = el.querySelectorAll('.tabs__list li')
                let cursor = el.querySelector('.cursor');
                let items = el.querySelectorAll('.tabs__item')
                let btnShowContent = el.querySelector('.show-content')

                list.forEach((l) => {
                    l.addEventListener('click', (e) => {
                        e.preventDefault();

                        if( l.classList.contains('active')) return;
                        l.classList.add('active')

                        let index = [...l.parentElement.children].indexOf(l);

                        let dir = index > current ? 1 : -1;

                        if( current >= 0 ) {
                            list[current].classList.remove('active')
                            gsap.to(items[current], { duration : 0.25, x : (dir * -30) +'%', autoAlpha : 0, ease : "cubic.inOut" })
                        }

                        gsap.fromTo(items[index], { x : (dir * 30) +'%', autoAlpha : 0 }, { duration : 0.25, x : '0%', autoAlpha : 1, ease : "cubic.out", delay : 0.12});

                        current = index;

                        let pos = l.getBoundingClientRect();
                        let posParent = l.parentNode.getBoundingClientRect();
                        gsap.to(cursor, { duration : 0.3, width : `${l.offsetWidth}px`, x : pos.x - posParent.x, ease : 'cubic.inOut'})

                        window.dispatchEvent(new Event('resize'))

                        if (initialClick > 1) {
                            let header_offset = 100;
                            let el_main_parent = l.closest('#resume');
                            if (el_main_parent) {
                                let element_pos = el_main_parent.offsetTop;
                                let offset_pos = element_pos - header_offset;
    
                                window.scrollTo({
                                    top: offset_pos,
                                    behavior: 'smooth'
                                });
                            }
                        }

                        initialClick++;
                    })
                })

                if(btnShowContent)
                    btnShowContent.addEventListener('click', (e) => {
                        setTimeout(function () {
                            window.dispatchEvent(new Event('resize'))
                        }, 200)
                    })

                window.addEventListener('resize', () => {
                    gsap.to(container, {duration: 0.2, height: items[current].offsetHeight});
                });

                if (document.body.dataset.lang == 'NL') {
                    if (list[0].closest('#resume')) {
                        list[1].dispatchEvent(new Event('click'));
                    } else {
                        list[0].dispatchEvent(new Event('click'));
                    }
                } else {
                    list[0].dispatchEvent(new Event('click'));
                }
            })
        }
    }

    /**
     * Read more button on albums text
     */
    initReadMore() {
        let read_more_btns = document.querySelectorAll('._rMore');

        if (read_more_btns) {
            read_more_btns.forEach((el) => {
                el.addEventListener('click', (e) => {
                    e.preventDefault();

                    let hidden_text = el.parentElement.querySelector('p .hide');
                    let dots = el.parentElement.querySelector('p .truncated');

                    if (hidden_text) {
                        let album_variants = document.querySelector('.album--variants');
                        let timeout = 0;

                        if (el.dataset.close === 'true') {
                            gsap.to(hidden_text, {duration: 0.25, autoAlpha: 0, ease: "power4.inOut"});

                            setTimeout(() => {
                                hidden_text.style.display = 'none';
                                dots.style.display = 'inline';
                                el.textContent = 'Lire la suite';
                                el.dataset.close = false;

                                let tabs_container = el.closest('.tabs__container');
                                let tabs_item = el.closest('.tabs__item');

                                tabs_container.style.height = tabs_item.offsetHeight+'px';
                                if (album_variants) {
                                    //album_variants.style.display = 'block';
                                    //gsap.to(album_variants, {duration: 0.25, autoAlpha: 1, ease: "power4.inOut"});
                                }
                            }, 251);
                        } else {
                            if (album_variants) {
                                timeout = 251;
                                //gsap.to(album_variants, {duration: 0.25, autoAlpha: 0, ease: "power4.inOut"});
                            }
    
                            setTimeout(() => {
                                //if (album_variants) { album_variants.style.display = 'none'; }
                                hidden_text.style.display = 'inline';
                                dots.style.display = 'none';
                                /*
                                if (album_variants) {
                                    el.textContent = 'Toutes les éditions';
                                } else {*/
                                    el.textContent = 'Lire moins';
                                //}
                                
                                el.dataset.close = true;

                                let tabs_container = el.closest('.tabs__container');
                                let tabs_item = el.closest('.tabs__item');

                                tabs_container.style.height = tabs_item.offsetHeight+'px';
                                gsap.to(hidden_text, {duration: 0.25, autoAlpha: 1, ease: "power4.inOut"});
                            }, timeout);
                        }
                    }
                });
            });
        }
    }

    /**
     * Anchro buttons, scroll to anchro on click
     */
    initAnchorBtns() {
        let btns = document.querySelectorAll('._bAnc:not([data-listener="true"])');

        if (btns) {
            btns.forEach((el) => {
                el.dataset.listener = true;
                el.addEventListener('click', (e) => {
                    e.preventDefault(), e.stopPropagation();

                    let anchor_el = document.getElementById(el.dataset.anc);
                    if (anchor_el) {
                        anchor_el.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    }
                });
            });
        }
    }

    /**
     * Init alerts btn, register to receive a newsletter or others is put in here
     */
    initAlertsBtns() {
        let btns = document.querySelectorAll('._bAlrt:not([data-listener="true"])');

        if (btns) {
            btns.forEach((el) => {
                el.dataset.listener = true;

                el.addEventListener('click', (e) => {
                    let type = el.dataset.type;
                    let id = el.dataset.id;
                    let url = site_url+'dispatcher/alerts';
                    
                    let form_alert_container = document.createElement('div');
                    form_alert_container.classList.add('alert');

                    let form_alert_form = document.createElement('form');
                    form_alert_form.classList.add('alert--form');
                    form_alert_form.addEventListener('submit', (e) => {
                        e.preventDefault(), e.stopPropagation();

                        let form_data = new FormData();
                        form_data.append('type', type);
                        form_data.append('id', id);
                        form_data.append('email', form_alert_form_input.value);

                        this._fetch_dispatcher(url, 'POST', form_alert_form, form_data);
                    });

                    let form_alert_form_input = document.createElement('input');
                    form_alert_form_input.type = 'email';
                    form_alert_form_input.name = 'email';
                    form_alert_form_input.placeholder = 'exemple@email.com';
                    form_alert_form_input.id = 'email_alerts';

                    let form_alert_form_submit = document.createElement('button');
                    form_alert_form_submit.classList.add('btn');
                    form_alert_form_submit.id = 'sub_alerts';
                    form_alert_form_submit.innerText = 'Ok';

                    let form_alert_form_err = document.createElement('small');
                    form_alert_form_err.classList.add('_errors', 'animate');

                    form_alert_form.appendChild(form_alert_form_input);
                    form_alert_form.appendChild(form_alert_form_submit);
                    form_alert_form.appendChild(form_alert_form_err);

                    form_alert_container.appendChild(form_alert_form);

                    el.parentElement.appendChild(form_alert_container);

                    gsap.to(el, {autoAlpha: 0, duration: .25, display: 'none', ease: 'power4.inOut'});
                    setTimeout(() => {
                        gsap.to(form_alert_container, {autoAlpha: 1, duration: .25, display: 'block', ease: 'power4.inOut'});
                    }, 251);
                });
            });
        }
    }

    /**
     * Init hash url management
     */
    initUrlHash() {
        let hash = window.location.hash;

        if (hash) {
            switch (hash) {
                case '#ba':
                    let video_sec = document.getElementById('_video');
                    if (video_sec) {
                        video_sec.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    }
                    break;
            }
        }
    }

    /**
     * Init the search module
     */
    initSearch() {
        let nav = document.querySelector('nav.main-nav');
        let searchbar = document.querySelector('.searchbar');
        let search = searchbar.querySelector('._sIn');
        let search_open = nav.querySelector('._s_o_sb');

        if (search && search_open) {
            let search_data = search.querySelector('#search');
            search_data.addEventListener('keyup', (e) => { e.preventDefault(), e.stopPropagation(), trigger_search(this); });
            let autocomplete_container = searchbar.querySelector('._s_ac');
            let close_btn = search.querySelector('._close');
            close_btn.addEventListener('click', (e) => {
                e.preventDefault(), e.stopPropagation();

                searchbar.classList.remove('is-visible');
                setTimeout(() => { nav.style.pointerEvents = 'all'; }, 251);
            });

            search.addEventListener('submit', (e) => { e.preventDefault(), e.stopPropagation(), trigger_search(this); });
            search_open.addEventListener('click', (e) => {
                e.preventDefault(), e.stopPropagation();

                nav.style.pointerEvents = 'none';
                searchbar.classList.add('is-visible');
                search_data.focus();
            });

            function trigger_search(_this) {
                if (!search_data.value || search_data.value.length < 3) {
                    autocomplete_container.parentElement.classList.remove('is-visible');
                    setTimeout(() => {
                        autocomplete_container.innerHTML = '';
                    }, 251);
                    return;
                }

                let url = site_url+'/dispatcher/search?'+search_data.name+'='+search_data.value;
                _this._fetch_dispatcher(url, 'GET', autocomplete_container);
            }

            window.addEventListener('click', (e) => {
                if (searchbar && !searchbar.contains(e.target)) {
                    searchbar.classList.remove('is-visible');
                    setTimeout(() => { nav.style.pointerEvents = 'all'; }, 251);
                }
            });
        }
    }

    /**
     * Init the newsletter module
     */
    initNewsletter() {
        let nav = document.querySelector('nav.main-nav');
        let nsbar = document.querySelector('.newsletterbar');
        let ns_forms = document.querySelectorAll('._nwsltr');
        let ns_open = nav.querySelector('._s_o_ns');
        
        if (nsbar && ns_open) {
            let close_btn = nsbar.querySelector('._close');
            close_btn.addEventListener('click', (e) => {
                e.preventDefault(), e.stopPropagation();

                nsbar.classList.remove('is-visible');
                setTimeout(() => { nav.style.pointerEvents = 'all'; }, 251);
            });

            ns_open.addEventListener('click', (e) => {
                e.preventDefault(), e.stopPropagation();

                nav.style.pointerEvents = 'none';
                nsbar.classList.add('is-visible');
            });

            window.addEventListener('click', (e) => {
                if (nsbar && !nsbar.contains(e.target)) {
                    nsbar.classList.remove('is-visible');
                    setTimeout(() => { nav.style.pointerEvents = 'all'; }, 251);
                }
            });
        }
        
        if (ns_forms) {
            ns_forms.forEach((el) => {
                el.addEventListener('submit', (e) => {
                    e.preventDefault(), e.stopPropagation();
                    
                    let url = site_url+'dispatcher/newsletter';
                    let email = el.querySelector('input[name="newsletter"]');
                    let form_data = new FormData();
                    form_data.append(email.name, email.value);

                    this._fetch_dispatcher(url, 'POST', el, form_data);
                });
            });
        }
    }

    /**
     * Init news gallery
     */
    initNewsGallery() {
        let gallery_imgs = document.querySelectorAll('.voirextrait');

        if (gallery_imgs) { // Create the gallery
            let _uniq = new Set();
            gallery_imgs.forEach((el) => {
                _uniq.add(el.href);
            });

            const lightbox = new FsLightbox();
            lightbox.props.sources = [..._uniq];

            let gallery_btns = document.querySelectorAll('.voirextrait.link');
            if (gallery_btns) {
                gallery_btns.forEach((el) => {
                    el.addEventListener('click', (e) => {
                        e.preventDefault();

                        lightbox.open();
                    });
                });
            }
        }

        let img_trigger_carousel = document.querySelectorAll('img[data-action]');

        if (img_trigger_carousel) {
            img_trigger_carousel.forEach((el) => {
                el.addEventListener('click', (e) => {
                    let trigger_img_gallery = document.querySelector('a.link[data-trigger="'+el.dataset.action+'"]');
                    trigger_img_gallery.dispatchEvent(new Event('click'));
                });
            });
        }

        // Single image
        let fancy = document.querySelectorAll('img.fancy');

        if (fancy) {
            fancy.forEach((el) => {
                const lightbox = new FsLightbox();
                lightbox.props.sources = [el.src];
                lightbox.props.onOpen = (e) => {
                    let fancy_big = document.querySelector('.fslightbox-source');

                    if (fancy_big) {
                        fancy_big.addEventListener('click', (e) => {
                            lightbox.close();
                        });
                    }
                }

                el.addEventListener('click', (e) => {
                    lightbox.open();
                });
            });
        }
    }

    /**
     * Dispatches to the righ action and process the response correctly
     * 
     * @param  {String} url 
     * @param  {String} method || POST or GET only atm
     * @param  {HTMLElement} || The container containing the data that needs updating
     * @param  {FormData} form_data || Form data used only when using "POST" method
     */
    _fetch_dispatcher(url, method, container, form_data = null) {
        if (url && method) {
            if (method === 'POST') {
                var init_fetch = {
                    method: method,
                    mode: 'same-origin',
                    credentials: 'same-origin',
                    body: form_data
                }
            } else if (method === 'GET') {
                var init_fetch = {
                    method: method,
                    mode: 'same-origin',
                    credentials: 'same-origin',
                }
            } else {
                throw new Error('Wrong method used (LW_ERR87984)');
            }

            if (init_fetch) {
                fetch(url, init_fetch).then(response => {
                    if (response.ok) {
                        return Promise.resolve(response);
                    } else {
                        return Promise.reject(new Error('Failed to load'));
                    }
                }).then(response => response.json()).then(data => {
                    let banner = document.querySelector('._mBan');
                    let banner_title = document.querySelector('._mBanTitle');
                    let banner_text = document.querySelector('._mBanText');
                    switch (data.type) {
                        case 'news':
                        case 'albums':
                            if (data.from === 'filter') {
                                container.style.height = container.offsetHeight+'px';
                                setTimeout(() => {
                                    if (data.type === 'albums') {
                                        gsap.to(banner, {duration: 0.25, opacity: 0});
                                        gsap.to(banner_title, {duration: 0.25, opacity: 0});
                                        gsap.to(banner_text, {duration: 0.25, opacity: 0});
                                    }
                                    gsap.to(container, {duration: 0.25, autoAlpha: 0});
                                    let video = document.querySelector('#_video');
                                    if (video) { gsap.to(video, {duration: 0.25, autoAlpha: 0, display: 'none'}); }
                                    setTimeout(() => { // Always remove last child as it is always faster to remove last element of an array
                                        while (container.firstChild) { container.removeChild(container.lastChild); }
                                        container.insertAdjacentHTML('beforeend', data.html);
                                        if (video) { video.remove(); }
                                        if (data.video === true) {
                                            let main = document.querySelector('main.main');
                                            main.insertAdjacentHTML('beforeend', data.video_html);
                                        }
                                        container.style.removeProperty('height');
                                        gsap.to(container, {duration: 0.25, autoAlpha: 1});
                                        let items = document.querySelectorAll('._lMore_i').length;
                                        let load_more = document.querySelector('._lMore');
                                        if (data.type === 'news') {
                                            _callback_functions_news(this);
                                        } else {
                                            banner.src = data.banner;
                                            banner_title.innerHTML = data.banner_title;
                                            banner_text.innerHTML = data.banner_text;

                                            gsap.to(banner, {duration: 0.25, opacity: 1});
                                            gsap.to(banner_title, {duration: 0.25, opacity: 1});
                                            gsap.to(banner_text, {duration: 0.25, opacity: 1});

                                            if (items < 12) {
                                                gsap.to(load_more, {duration: 0.25, autoAlpha: 0, display: 'none'});
                                            } else {
                                                gsap.to(load_more, {duration: 0.25, autoAlpha: 1, display: 'block'});
                                            }
                                            _callback_functions_albums(this);
                                        }
                                    }, 251);
                                }, 1);
                            } else if (data.from === 'load_more') {
                                let load_more = document.querySelector('._lMore');
                                container.insertAdjacentHTML('beforeend', data.html);
                                if (data.load_more === false) { gsap.to(load_more, {duration: 0.25, autoAlpha: 0, display: 'none'}); }
                                if (data.type === 'news') {
                                    _callback_functions_news(this);
                                } else {
                                    _callback_functions_albums(this);
                                }
                            }
                            break;
                        case 'alerts':
                        case 'newsletter':
                            if (data.errors) {
                                for (const key in data.errors) {
                                    let input = container.querySelector('input[name="'+key+'"]');
                                    console.log(input);
                                    if (input) {
                                        let input_err = input.parentElement.querySelector('._errors');
                                        if (input_err.textContent !== '') {
                                            input_err.classList.remove('shakeX');
                                            setTimeout(() => {
                                                input_err.classList.add('shakeX');
                                            }, 1);
                                        } else {
                                            input_err.textContent = data.errors[key];
                                            gsap.to(input_err, {duration: 0.25, opacity: 1, ease: 'power4.inOut'});
                                        }
                                    }
                                }
                            } else if (data.success === true) {
                                let parent = container.parentElement;
                                gsap.to(parent, {duration: 0.25, autoAlpha: 0, ease: 'power4.inOut'});
                                setTimeout(() => {
                                    container.remove();
                                    parent.innerHTML = '<span class="success">'+data.message+'</span>';
                                    gsap.to(parent, {duration: 0.25, autoAlpha: 1, ease: 'power4.inOut'});
                                }, 251);
                            }
                            break;
                        case 'cart':
                            if (data.cart.content && data.item.ean) {
                                let cart_nbitems = document.querySelector('._nb_c');
                                // Empty cart injection
                                if (data.cart.items <= 0) {
                                    let cart_top = document.querySelector('.cart--top');
                                    let cart__container = document.querySelector('.cart__container');
                                    let cart__footer = document.querySelector('.cart__footer');
                                    gsap.to(cart_top, {duration: 0.25, autoAlpha: 0, ease: 'power4.inOut'});
                                    gsap.to(cart__container, {duration: 0.25, autoAlpha: 0, ease: 'power4.inOut'});
                                    if (cart_nbitems) { gsap.to(cart_nbitems, {duration: 0.25, autoAlpha: 0, ease: 'power4.inOut'}); }

                                    setTimeout(() => {
                                        cart_top.classList.add('empty');
                                        cart__container.remove();
                                        if (cart_nbitems) cart_nbitems.remove();
                                        if (cart__footer) cart__footer.remove();
                                        cart_top.innerHTML = '<h2 class="-uppercase">Votre panier est vide.</h2>';
                                        gsap.to(cart_top, {duration: 0.25, autoAlpha: 1, ease: 'power4.inOut'});
                                    }, 251);
                                } else {
                                    if (!cart_nbitems) {
                                        let header_cart_btn = document.querySelector('._bCrt');
                                        if (header_cart_btn) {
                                            let new_cart_nbitems = document.createElement('span');
                                            new_cart_nbitems.classList.add('nb-cart', '_nb_c');
                                            let new_cart_nbitems_count = document.createElement('span');
                                            new_cart_nbitems_count.textContent = data.cart.items;
                                            new_cart_nbitems.appendChild(new_cart_nbitems_count);
                                            header_cart_btn.appendChild(new_cart_nbitems);
                                        }
                                    } else {
                                        cart_nbitems.querySelector('span').textContent = data.cart.items;
                                    }
                                }

                                // Start normal cart processing
                                let item = data.item;
                                let ean = item.ean;
                                let mod_row = document.querySelector('._cItm[data-ean="'+ean+'"]');
                                if (mod_row) { var mod_row_input = mod_row.querySelector('input[name="qty"]'); }
                                let mod_row_form_input = document.querySelector('.cart--order input[name="batch['+ean+']"]');

                                // If item already in cart
                                if (mod_row && mod_row_form_input) {
                                    if (data.cart.content[ean]) {
                                        mod_row_input.value = data.cart.content[ean];
                                        mod_row_form_input.value = data.cart.content[ean];
                                    } else {
                                        gsap.to(mod_row, {duration: 0.25, autoAlpha: 0, ease: 'power4.inOut'});
                                        setTimeout(() => {
                                            mod_row.remove();
                                            mod_row_form_input.remove();
                                        }, 251);
                                    }
                                } else { // Else item not in cart, remove it
                                    // Prepare the item
                                    let couv_url;
                                    if (item.couverture) {
                                        couv_url = base_url+'assets-upload/'+item.couverture;
                                    } else if (item.bda_couv) {
                                        couv_url = item.bda_couv;
                                    } else {
                                        if (item.bda_images_json) {
                                            couv_url = JSON.parse(item.bda_images_json).primary.url;
                                        } else {
                                            couv_url = base_url+'assets/dist/img/preload_album.gif';
                                        }
                                    }

                                    let inject_item_html = 
                                        '<div class="cart--item _cItm" data-ean="'+ean+'">'+
                                            '<figure>'+
                                                '<div class="inner">'+
                                                    '<a href="'+base_url+'albums/'+item.slug+'">'+
                                                        '<img class="js-lazy" src="'+base_url+'assets/dist/img/preload_album.gif" data-src="'+couv_url+'" alt="'+item.titre+'">'+
                                                    '</a>'+
                                                '</div>'+
                                            '</figure>'+
                                            '<div class="cart--item--infos">'+
                                                '<h3 class="-uppercase">'+item.titre+'</h3>'+
                                                '<div class="more">'+
                                                    '<span class="price">'+item.prix+'&euro;</span>'+
                                                    '<span class="quantity">'+
                                                        '<button class="_qtyM" data-qty="less">-</button>'+
                                                        '<input type="text" name="qty" value="'+item.quantity+'" disabled>'+
                                                        '<button class="_qtyM" data-qty="more">+</button>'+
                                                    '</span>'+
                                                '</div>'+
                                                '<button class="delete _rmC">'+
                                                    '<i class="icon icon--delete "><svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 300 300" style="enable-background:new 0 0 300 300;" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}</style><path class="st0" d="M243.8,56.3h-46.9l-13.4-18.8h-67l-13.4,18.8H56.3V75h187.5L243.8,56.3z M87,238.4c0.3,13.5,11.5,24.3,25,24.1h76h0c13.5,0.2,24.7-10.6,25-24.1l12-144.6H75L87,238.4z"></path></svg></i>'+
                                                '</button>'+
                                            '</div>'+
                                        '</div>'
                                    ;

                                    // Check if cart is empty first
                                    let empty_cart = document.querySelector('.cart--top.empty');
                                    if (empty_cart) { // If it's empty, need to create the whole template
                                        let inject_cart_template_html = 
                                            '<div class="cart--top"><h2 class="-uppercase">Votre panier (<span class="_cTQty">'+data.cart.items+'</span>)</h2></div>'+
                                            '<div class="cart__container">'+
                                                '<div class="cart--total">'+
                                                    '<h4 class="-uppercase">Total</h4>'+
                                                    '<div class="total u-tar">'+
                                                        '<span class="price"><span class="_cTt">'+data.cart.total+'</span>&euro;</span><small>+ frais d\'envoi</small>'+
                                                    '</div>'+
                                                    '<form class="cart--order" action="https://9e-store.fr/cart/" method="post" target="_blank">'+
                                                        '<input type="hidden" name="_method" value="PATCH" />'+
                                                        '<input type="hidden" name="batch['+item.ean+']" value="'+item.quantity+'" />'+
                                                        '<button class="btn _bOdr">Finaliser ma commande</button>'+
                                                    '</form>'+
                                                '</div>'+
                                            '</div>'+
                                            '<div class="cart__footer">'+
                                                '<div class="cart__footer--content">'+
                                                    '<figure><div class="inner"><img src="'+base_url+'assets/dist/img/powerby9store.jpg"></div></figure>'+
                                                '</div>'+
                                                '<iframe id="AV_widget_iframe" frameBorder="0" width="100%" height="330" src="//cl.avis-verifies.com/fr/cache/7/c/8/7c812eed-a810-5d64-e91f-5265c97ce950/widget4/7c812eed-a810-5d64-e91f-5265c97ce950horizontal_index.html"></iframe>'+
                                            '</div>'
                                        ;
                                        
                                        empty_cart.insertAdjacentHTML('beforebegin', inject_cart_template_html);
                                        setTimeout(() => {
                                            empty_cart.remove();
                                        }, 1);
                                    }
                                    
                                    // Then we add items to the cart template and to the PATCH form
                                    let total_container = document.querySelector('.cart--total');
                                    total_container.insertAdjacentHTML('beforebegin', inject_item_html);
                                    
                                    let patch_form = total_container.querySelector('form.cart--order');
                                    if (patch_form) {
                                        if (!patch_form.querySelector('input[name="batch['+ean+']"]')) {
                                            let new_patch = '<input type="hidden" name="batch['+ean+']" value="'+item.quantity+'">';
                                            patch_form.querySelector('._bOdr').insertAdjacentHTML('beforebegin', new_patch);
                                        } else {
                                            patch_form.querySelector('input[name="batch['+ean+']"]').value = item.quantity;
                                        }
                                    }

                                    setTimeout(() => {
                                        let new_items = document.querySelectorAll('._cItm:not([data-listener="true"])');
                                        new_items.forEach((el) => {
                                            el.dataset.listener = true;
                                            this._cart_qty_btns(el, el.dataset.ean);
                                        });

                                        this.lazyLoading();
                                    }, 1);
                                }
                                
                                setTimeout(() => {
                                    let mod_total_items = document.querySelector('._cTQty');
                                    mod_total_items.textContent = data.cart.items;
                                    let mod_total = document.querySelector('._cTt');
                                    mod_total.textContent = data.cart.total;
                                }, 101);
                            }
                            break;
                        case 'perso':
                        case 'auteur':
                            let title = container.querySelector('._title');
                            let role = container.querySelector('._sub_title');
                            let bio = container.querySelector('._bio');
                            let alb_title = container.querySelector('._alb_title');
                            let albums_carousel = container.querySelectorAll('.carousel');

                            gsap.to(container, {duration: 0.25, autoAlpha: 0});
                            setTimeout(() => {
                                title.textContent = data.item.titre || data.item.prenom+' '+data.item.nom;
                                role.textContent = data.item.sous_titre || data.item.role;
                                bio.innerHTML = data.item.bio;
                                alb_title.textContent = data.albums_title;

                                albums_carousel.forEach((el, index) => {
                                    delete el.dataset.listener;
                                    window.flkty_fs[index].destroy();
                                    if (data.albums_html) {
                                        el.innerHTML = data.albums_html;
                                        this.initFreeScrollCarousel();
                                    } else {
                                        el.innerHTML = '';
                                    }
                                });

                                gsap.to(container, {duration: 0.25, autoAlpha: 1});
                            }, 251);
                            
                            break;
                        case 'univ':
                        case 'aut':
                            let html_container = document.querySelector('._uCar');
                            html_container.classList.remove('flickity-enabled', 'is-draggable');
                            html_container.removeAttribute('tabindex');
                            delete html_container.dataset.listener;
                            let html_bio_container = document.querySelector('._uDsc');
                            let html_bio_albums_carousel = html_bio_container.querySelectorAll('.carousel');

                            let parent = html_container.parentElement;

                            gsap.to(banner, {duration: 0.25, opacity: 0});
                            gsap.to(banner_title, {duration: 0.25, opacity: 0});
                            gsap.to(parent, {duration: 0.25, opacity: 0});
                            parent.style.height = parent.scrollHeight+'px';
                            gsap.to(html_bio_container, {duration: 0.25, opacity: 0});

                            setTimeout(() => {
                                banner.src = data.banner;
                                banner_title.innerHTML = data.banner_title;
                                banner_text.innerHTML = data.banner_text;

                                gsap.to(banner, {duration: 0.25, opacity: 1});
                                gsap.to(banner_title, {duration: 0.25, opacity: 1});

                                window.flkty_persos.destroy();
                                html_container.textContent = '';
                                html_container.insertAdjacentHTML('afterbegin', data.html);
                                html_bio_container.textContent = '';
                                html_bio_container.insertAdjacentHTML('afterbegin', data.html_bio);
                                html_bio_albums_carousel.forEach((el, index) => { window.flkty_fs[index].destroy(); });
                            }, 251);
                            setTimeout(() => {
                                this.lazyLoading();
                                this.initCarouselPersonnages();
                                this.initFreeScrollCarousel();
                            }, 252);
                            setTimeout(() => {
                                gsap.to(parent, {duration: 0.25, opacity: 1});
                                gsap.to(html_bio_container, {duration: 0.25, opacity: 1});
                            }, 451);
                            setTimeout(() => { parent.style.removeProperty('height'); }, 1001);
                            break;
                        case 'search':
                            container.innerHTML = data.content;
                            
                            if (data.content) {
                                container.parentElement.classList.add('is-visible');
                            } else {
                                container.parentElement.classList.remove('is-visible');
                            }
                            break;
                    }
                }).catch((err) => {
                    throw new Error(err.message);
                });

                function _callback_functions_news(_this) {
                    _this.initNewsActions();
                    _this.lazyLoading();
                    _this.initInViewItems();
                }

                function _callback_functions_albums(_this) {
                    _this.lazyLoading();
                    _this.initInViewItems();
                    _this.initReader();
                    _this.initPlayer();
                    _this.initCart();
                }
            }
        }
    }

    /**
     * Toggle the dropdown menu when hovering
     * 
     * @param  {HTMLElement} el
     * @param  {HTMLElement} dropdown
     * @param  {HTMLElement} dropdown_wrapper
     */
    _toggle_dropdown(el, dropdown, dropdown_wrapper) {
        console.log('TOGGLE', el);
    }

    /**
     * Open the dropdown
     * 
     * @param  {HTMLElement} el
     * @param  {HTMLElement} dropdown
     * @param  {HTMLElement} dropdown_wrapper
     */
    _open_dropdown(el, dropdown, dropdown_wrapper) {
        let all_els = document.querySelectorAll('.root-dropdown__wrapper--el');
        all_els.forEach((elm) => { elm.classList.remove('root-dropdown__wrapper--el--visible'); });
        let dropdown_to_open = document.querySelector('.root-dropdown__wrapper--el[data-target="'+el.dataset.dropdown+'"]');
        let prev = dropdown_to_open.previousElementSibling;
        let next = dropdown_to_open.nextElementSibling;

        if (dropdown_to_open.classList.contains('root-dropdown__wrapper--el-right')) {
            dropdown_to_open.classList.remove('root-dropdown__wrapper--el-right');
            if (prev) prev.classList.add('root-dropdown__wrapper--el-left');
            if (next) next.classList.add('root-dropdown__wrapper--el-right');
        } else if (dropdown_to_open.classList.contains('root-dropdown__wrapper--el-left')) {
            dropdown_to_open.classList.remove('root-dropdown__wrapper--el-left');
            if (prev) prev.classList.add('root-dropdown__wrapper--el-left');
            if (next) next.classList.add('root-dropdown__wrapper--el-right');
        }

        let element_offsetLeft = el.offsetLeft - 35;
        if (element_offsetLeft < 0) { element_offsetLeft = 0; }

        dropdown_wrapper.style.width = dropdown_to_open.scrollWidth+'px';
        dropdown_wrapper.style.setProperty('--cardHeight', dropdown_to_open.scrollHeight+'px');
        dropdown_wrapper.style.setProperty('--offsetLeftMenu', '-'+element_offsetLeft+'px');
        dropdown_wrapper.style.setProperty('--menuRotateX', '0deg');
        dropdown.classList.add('root-dropdown--visible');
        dropdown_wrapper.style.pointerEvents = 'auto';

        dropdown_to_open.classList.add('root-dropdown__wrapper--el--visible');
    }
    /**
     * Start the closing timeout
     * 
     * @param  {HTMLElement} dropdown
     * @param  {HTMLElement} dropdown_wrapper
     */
    _td_start_close_timeout(dropdown, dropdown_wrapper) {
        dropdown_timeout = setTimeout(() => {
            dropdown.classList.remove('root-dropdown--visible');
            dropdown_wrapper.style.removeProperty('--menuRotateX');
            dropdown_wrapper.style.pointerEvents = 'none';
        }, 150);
    }

    /**
     * Stop the closing timeout
     * 
     * @param  {HTMLElement} dropdown
     * @param  {HTMLElement} dropdown_wrapper
     */
    _td_stop_close_timeout(dropdown, dropdown_wrapper) {
        clearTimeout(dropdown_timeout);
    }

    /**
     * Build the html for the bd reader
     * 
     * @param {String} token 
     */
    _bdreader_builder(token) {
        let iframeModal = document.createElement('div');
        iframeModal.classList.add('iframe__modal');

        let iframeElement = document.createElement('iframe');
        iframeElement.src = 'https://player.dlpdomain.com/player-display?do=html&token='+token;
        iframeElement.setAttribute('width', '100%');
        iframeElement.setAttribute('height', '100%');
        iframeElement.setAttribute('frameborder', 0);
        iframeElement.setAttribute('scrolling', 'no');
        iframeElement.setAttribute('allowfullscreen', '');

        let iframeQuit = document.createElement('span');
        iframeQuit.classList.add('close');
        iframeQuit.setAttribute('onclick', 'window.closeIframe(this);');
        iframeQuit.innerHTML = '&nbsp;Retour au site';

        let iframeQuitIcon = document.createElement('span');
        iframeQuitIcon.classList.add('icon-gauche');
        iframeQuitIcon.innerHTML = '&#8249;';

        let iframeLoader = document.createElement('div');
        iframeLoader.classList.add('loader');
        iframeQuit.appendChild(iframeQuitIcon);
        iframeModal.appendChild(iframeElement);
        iframeModal.appendChild(iframeQuit);
        iframeModal.appendChild(iframeLoader);

        document.body.appendChild(iframeModal);

        setTimeout(() => {
            iframeModal.classList.add('show');
        }, 250);

        iframeElement.addEventListener('load', () => {
            setTimeout(() => {
                iframeLoader.classList.add('hide');
                iframeLoader.style.display = 'none';
            }, 250);
        });
    }

    /**
     * Build the html for the video player
     * 
     * @param {String} token
     */
    _vplayer_builder(token) {
        if (token) {
            let pointer = document.querySelector('.pointer-close');

            let yt_cookie = document.cookie.split('!');
            let yt_cookie_wait = yt_cookie.indexOf('youtube=wait');
            let yt_cookie_false = yt_cookie.indexOf('youtube=false');

            let videoModal = document.createElement('div');
            videoModal.classList.add('container--video');

            if (yt_cookie_wait >= 0 || yt_cookie_false >= 0) {
                var videoEmbed = document.createElement('div');
                videoEmbed.classList.add('no-cookie');
                videoEmbed.innerHTML = '<span>L\'affichage des vidéos est bloqué par vos préférences de cookies.</span>';

                videoModal.appendChild(videoEmbed);
            } else {
                var videoEmbed = document.createElement('iframe');
                videoEmbed.src = 'https://www.youtube-nocookie.com/embed/'+token.split('?v=')[1]+'?autoplay=1';
                videoEmbed.setAttribute('frameborder', 0);
                videoEmbed.setAttribute('scrolling', 'no');
                videoEmbed.setAttribute('allowfullscreen', '');

                videoModal.appendChild(videoEmbed);
            } 

            document.body.appendChild(videoModal);

            HTML.addEventListener('mousemove', moveCursor);
            HTML.dispatchEvent(new Event('mousemove'));

            function moveCursor(e) {
                pointer.style.left = `${e.clientX}px`
                pointer.style.top = `${e.clientY}px`
            }

            // Lock scroll
            let prev_scroll = {
                x: window.pageXOffset,
                y: window.pageYOffset
            }

            document.documentElement.style.position = 'fixed';
            document.documentElement.style.width = '100%';
            document.documentElement.style.top = -prev_scroll.y+'px';
            document.documentElement.style.left = -prev_scroll.x+'px';
            document.documentElement.style.overflowY = 'hidden';
            
            pointer.style.opacity = 1;

            gsap.to(videoModal, {duration: 1, autoAlpha: 1, ease: 'power4.inOut'});
            gsap.to(videoEmbed, {duration: 1, y: '-50%', autoAlpha: 1, ease: 'power4.inOut'});

            closevEmbed(videoModal, videoEmbed, pointer, prev_scroll);

            function closevEmbed(modal, video, pointer, prev_scroll) {
                if (modal) {
                    // Handler if the cookie modal is opened (should happen very rarely tho)
                    let c_modal_opener = document.querySelectorAll('#tarteaucitronCloseAlert');
        
                    if (c_modal_opener) {
                        c_modal_opener.forEach((el) => {
                            el.addEventListener('click', (e) => {
                                _mAnim();
                            });
                        });
                    }
        
                    modal.addEventListener('click', (m) => {
                        m.preventDefault();
        
                        _mAnim();
                    });
        
                    function _mAnim() {
                        gsap.to(modal, {duration: 1, autoAlpha: 0, ease: 'power4.inOut'});
                        gsap.to(video, {duration: 1, y: '0%', autoAlpha: 0, ease: 'power4.inOut'});
        
                        document.documentElement.style.position = 'relative';
                        document.documentElement.style.width = 'auto';
                        document.documentElement.style.top = 'unset';
                        document.documentElement.style.left = 'unset';
                        document.documentElement.style.overflowY = 'scroll';
        
                        pointer.style.opacity = 0;
                        
                        window.scrollBy(prev_scroll.x, prev_scroll.y);
        
                        setTimeout(() => {
                            modal.remove();
                        }, 1000);
                    }
                }
            }
        }
    }

    /**
     * Manage cart qty buttons
     * 
     * @param  {HTMLElement} item
     * @param  {String} ean
     */
    _cart_qty_btns(item, ean) {
        if (item && ean) {
            let qty_btns = item.querySelectorAll('._qtyM:not([data-listener="true"])');
            let rm_btn = item.querySelector('._rmC:not([data-listener="true"])');
            let url, qty;

            if (qty_btns) {
                qty_btns.forEach((el) => {
                    el.dataset.listener = true;

                    el.addEventListener('click', (e) => {
                        e.preventDefault(), e.stopPropagation();

                        let form_data = new FormData();
                        form_data.append('ean', ean);

                        switch (el.dataset.qty) {
                            case 'less':
                                url = site_url+'cart/less';
                                qty = -1;
                                break;
                            case 'more':
                                url = site_url+'cart/more';
                                qty = 1;
                                break;
                            default:
                                return;
                        }
                        
                        form_data.append('qty', qty);
                        this._fetch_dispatcher(url, 'POST', item, form_data);
                    });
                });
            }

            if (rm_btn) {
                rm_btn.dataset.listener = true;
                rm_btn.addEventListener('click', (e) => {
                    e.preventDefault(), e.stopPropagation();

                    url = site_url+'cart/less';

                    let form_data = new FormData();
                    form_data.append('ean', ean);
                    form_data.append('void', true);

                    this._fetch_dispatcher(url, 'POST', item, form_data);
                });
            }
        } else {
            return;
        }
    }
}

window.addEventListener('load', function() {
    new App();
});

/**
 * Close iframe
 * 
 * @param {HTMLElement} el 
 */
window.closeIframe = (el) => {
    let iframeModale = document.querySelector('.iframe__modal');
    iframeModale.classList.remove('show');
    iframeModale.classList.add('hide');
    setTimeout(() => {
        iframeModale.remove();
    }, 250);
}

/**
 * Cookie modal
 * 
 * @param {HTMLElement} tac_open_modal 
 */
window.tacM = (tac_open_modal) => {
    // First, bottom banner animation
    let bot_ban = document.querySelector('#tarteaucitronAlertBig');

    if (bot_ban) {
        gsap.to(bot_ban, {delay: 0, autoAlpha: 1, y: -20, duration: .15, ease: 'power4.inOut'});
    }

    // Init modal objects to animate
    let tac_bak = document.querySelector('#tarteaucitronBack');
    let tac_modak = document.querySelector('div#tarteaucitron');
    let tac_clak = document.querySelector('#tarteaucitronClosePanel');

    if (tac_bak && tac_modak && tac_clak) {
        tac_bak.addEventListener('click', (e) => {
            gsap.to(tac_bak, {autoAlpha: 0, duration: 0, display: 'none', ease: 'power4.inOut'});
            gsap.to(tac_modak, {autoAlpha: 0, y: 0, duration: 0, display: 'none', ease: 'power4.inOut'});
        });

        tac_clak.addEventListener('click', (e) => {
            gsap.to(tac_bak, {autoAlpha: 0, duration: 0, display: 'none', ease: 'power4.inOut'});
            gsap.to(tac_modak, {autoAlpha: 0, y: 0, duration: 0, display: 'none', ease: 'power4.inOut'});
        });

        if (tac_open_modal) {
            tac_open_modal.forEach((el) => {
                el.addEventListener('click', (e) => {
                    gsap.to(tac_bak, {autoAlpha: 1, duration: 0, ease: 'power4.inOut'});
                    gsap.to(tac_modak, {autoAlpha: 1, y: -20, duration: 0, ease: 'power4.inOut'});
                });
            });
        }
    }
}